import { useColorable } from "./useColorable.mjs";
export function useListItemComponent(props) {
  const { colorClass, colorModifierClass, colorHex } = useColorable(props);
  return {
    colorClass,
    colorModifierClass,
    colorHex
  };
}
